import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "./Funding.css";
import { fundingProjects } from "../../data/fundingData";

const Funding: React.FC = () => {
  const [isDesktop, setIsDesktop] = useState(window.innerWidth > 768);

  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth > 768);
    };
    window.addEventListener("resize", handleResize);
    handleResize(); // Initial check
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <section id="funding" className="funding-section">
      <div className="funding-container">
        <h2 className="funding-title">진행 중인 프로젝트</h2>
        {/* Outer Swiper for Projects */}
        <Swiper
          modules={[Pagination, Navigation]}
          pagination={{ clickable: true }}
          navigation={true}
          spaceBetween={100}
          slidesPerView={1}
          className="funding-project-swiper"
        >
          {fundingProjects.map((project) => (
            <SwiperSlide key={project.id}>
              <div className="funding-content-wrapper">
                {/* Inner Content: Swiper for Images OR Placeholder */}
                <div className="funding-slider-wrapper">
                  {project.images.length > 0 ? (
                    <Swiper
                      key={
                        isDesktop
                          ? `desktop-${project.id}`
                          : `mobile-${project.id}`
                      }
                      modules={[Pagination]}
                      pagination={{ clickable: true }}
                      spaceBetween={isDesktop ? -80 : 20}
                      slidesPerView={isDesktop ? 3 : 1}
                      centeredSlides={false}
                      loop={true}
                      nested={true}
                      slideToClickedSlide={true}
                      className="funding-swiper"
                    >
                      {project.images.map((img, index) => (
                        <SwiperSlide key={`${img.id}-${index}`}>
                          <div className="funding-card">
                            <img
                              src={img.src}
                              alt={img.alt}
                              className="funding-card-img"
                            />
                          </div>
                        </SwiperSlide>
                      ))}
                    </Swiper>
                  ) : (
                    <div className="funding-placeholder-card">
                      <div className="placeholder-content">
                        <span>준비 중...</span>
                      </div>
                    </div>
                  )}
                </div>

                {/* Project Details */}
                <div className="funding-details-wrapper">
                  <h3 className="funding-details-title">{project.title}</h3>
                  <p className="funding-details-content">
                    {project.description.split("\n").map((line, i) => (
                      <React.Fragment key={i}>
                        {line}
                        <br />
                      </React.Fragment>
                    ))}
                  </p>
               <a
                    href="https://airbridge.tumblbug.com/1wg4jr"
                    target="_blank"
                    rel="noopener noreferrer"
                    className=" text-center button block w-40 mt-8 mb-8 bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600"
                  >
                    프로젝트 바로가기
                  </a>
                </div>
              </div>
            </SwiperSlide>
          ))}
          {/* Custom Pagination Container if needed, or rely on built-in */}
          <div className="funding-project-pagination"></div>
        </Swiper>
      </div>
    </section>
  );
};

export default Funding;
